export enum TourE {
  ATTENDANCE_TOUR = 'ATTENDANCE_TOUR',
  DASHBOARD_TOUR = 'DASHBOARD_TOUR',
  NAVBAR_TOUR = 'NAVBAR_TOUR',
  SES_CONFIG_TOUR = 'SES_CONFIG_TOUR',
}
